import React from "react"
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export default function WorkTogether() {

    const data = useStaticQuery(graphql`
        query {
            allFile(
                filter: {
                    relativeDirectory: { eq: "work-together" }, 
                    extension: {regex: "/(jpg|jpeg|png)/"}
                }
            ) {
                edges {
                    node {
                        name
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
                        }   
                    }
                }
            }
        }   
  `);

    let images = {};
    data.allFile.edges.forEach(edge => {
        images[edge.node.name] = getImage(edge.node.childImageSharp);
    });

    return (
        <section className="pb-4 sm-pt-30px sm-pb-40px overflow-hidden position-relative">
            <div className="container">
                <div
                    className="row"
                    data-anime={JSON.stringify({"el": "childs", "translateY": [0, 0], "opacity": [0,1], "duration": 500, "delay": 200, "staggervalue": 300, "easing": "easeOutQuad" })}
                >
                    <div className="col-sm-5 text-center text-sm-start">
                        <div className="outside-box-left-25 xl-outside-box-left-10 sm-outside-box-left-0">
                            <div className="fs-350 xl-fs-250 lg-fs-200 md-fs-170 sm-fs-100 text-dark-gray fw-600 ls-minus-20px word-break-normal">
                                work
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-7 text-center text-sm-end">
                        <div className="outside-box-right-5 sm-outside-box-right-0">
                            <div className="fs-350 xl-fs-250 lg-fs-200 md-fs-170 sm-fs-100 text-base-color fw-600 ls-minus-20px position-relative d-inline-block word-break-normal">
                                together
                                <div
                                    className="position-absolute left-minus-140px top-minus-140px z-index-9 xl-left-minus-110px top-minus-140px xl-top-minus-100px md-top-minus-90px z-index-9 xl-w-230px md-w-200px d-none d-md-block"
                                    data-anime={JSON.stringify({ "translateY": [-15, 0], "scale": [0.5, 1], "opacity": [0,1], "duration": 800, "delay": 200, "staggervalue": 300, "easing": "easeOutQuad" })}
                                >
                                    {images['work-together-circle'] && (
                                        <GatsbyImage
                                            image={images['work-together-circle']}
                                            className="animation-rotation"
                                            alt="matrixbrains pvt ltd works together circle"
                                            loading="lazy"
                                        />
                                    )}
                                    <div className="absolute-middle-center w-100 z-index-minus-1">
                                        {images['one-circle'] && (
                                            <GatsbyImage
                                                image={images['one-circle']}
                                                alt="Matrixbrains pvt ltd works together one circle"
                                                loading="lazy"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
